import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, CHALLAN_TYPE, decryptText, ENUM_ADVSEARCH_PARAM, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_PAGEACTION_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, getModMandatory, getModValue, linksUrl, SALE_PUR_ENTRY_TYPE, URIEncrypt } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faFileInvoice,
  faPlus,
  faReceipt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetReturnDetailParams, setReturnDetailParams,  setReturnNewEntryMode } from "../../state/memoEntrySlice"



const ReturnEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { compCode, isMultipleCompany, yearId, CurrencySetting } = useSelector((state) => state.company)
  let [itemToDelete, setItemToDelete] = useState("")
  const [itemToEdit, setItemToEdit] = useState("")
  const [pageActionType, setPageActionType] = useState("")
  const { btype, trdtype, ptype } = useParams()
  const [entryLabel, setEntryLabel] = useState()
  const [selBillType, setSelBillType] = useState()
  const [selTradeOf, setSelTradeOf] = useState()
  const [selPktType, setSelPktType] = useState()
  const [naviCode, setnaviCode] = useState()
  //const [data, setData] = useState([])
  const [selAdvanceFilter, setSelAdvanceFilter] = useState({})
  const [pageApiAdvFilter, setPageApiAdvFilter] = useState({})
  const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard.tradingDashboard)
    disapatch(resetReturnDetailParams())




    const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
    if (!params.includes(String(trdtype))
      || ![URIEncrypt.Sale, URIEncrypt.Purchase].includes(String(btype))
      || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(String(ptype))
    )
      navigate(linksUrl.dashboard.tradingDashboard)

    if (btype && btype != "" && trdtype && trdtype != "" || ptype && ptype != "") {

      let t_trdtype = trdtype.toLowerCase()
      let t_btype = btype.toLowerCase()
      let t_tradeof = ''
      let t_entryLabel = ''
      let t_billtype = ''
      let t_ptype = ''


      if (ptype == URIEncrypt.SinglePacket)
        t_ptype = 'SNG'
      else
        t_ptype = 'MIX'

      if (t_btype == URIEncrypt.Sale.toLowerCase()) {
        t_billtype = 'T'
      }
      else if (t_btype == URIEncrypt.Purchase.toLowerCase()) {
        t_billtype = 'N'
      }
      if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
        t_tradeof = ENUM_TRADEOF_CODE.Polish
        t_entryLabel = "Polish Diamond "
        setnaviCode(t_billtype == 'T' ? linksUrl.saleEntry.polishDiamond : t_billtype == 'N' ? linksUrl.purchaseEntry.polishDiamond : "")
      }
      else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
        t_tradeof = ENUM_TRADEOF_CODE.Rough
        t_entryLabel = "Rough Diamond "
        setnaviCode(t_billtype == 'T' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'N' ? linksUrl.purchaseEntry.roughDiamond : "")
      }
      else if (t_trdtype == URIEncrypt.Rejection.toLowerCase()) {
        t_tradeof = ENUM_TRADEOF_CODE.Rejection
        t_entryLabel = "Rejection Diamond "
        setnaviCode(t_billtype == 'T' ? linksUrl.saleEntry.rejectDiamond : t_billtype == 'N' ? linksUrl.purchaseEntry.rejectDiamond : "")
      }

      setSelTradeOf(t_tradeof)
      setSelBillType(t_billtype)
      setEntryLabel(t_entryLabel)
      setSelPktType(t_ptype)
      funFilterData(t_billtype, t_tradeof, t_ptype, null, null, null, null, null, null, null, null, null, null);
      setPageApiAdvFilter({ CompCode: compCode.join(','), BillType: t_billtype, TradeOf: t_tradeof })
    }


  }, [btype, trdtype, ptype])
  const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
    url: apiRoute.modSetting.getModSetting,
    queryKey: "fetchModSettingCurrency",
    inputData: {
      mod_name: ENUM_MOD_NAME.GeneralSettings
    }
  })
  useEffect(() => {
    if (modSetting && modSetting.length > 0) {
      const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
      setIsUseMfgNoAsMktno(mktSetting)
    }
  }, [modSetting])
  const {
    isError,
    isPending,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.memoEntry.fetch,
    queryKey: "Memo Data List",

  })
  const funFilterData = (billtype, tradeof, pkttype, scode, qcode, szcode, shcode, lwcode, itemcode, pacid, brid, fromdate, todate) => {
    filterData({
      data: {
        compcode: compCode.join(","),
        billtype: billtype,
        tradeof: tradeof,
        pkttype: pkttype == 'SNG' ? pkttype : '',
        s_code: scode,
        q_code: qcode,
        sh_code: shcode,
        sz_code: szcode,
        lw_code: lwcode,
        item_code: itemcode,
        pac_id: pacid,
        br_id: brid,
        from_date: fromdate,
        to_date: todate

      }
    })

  }



  const onSuccessDelete = (data) => {
    setItemToDelete("")
    toast.success("deleted successfully", {
      position: "top-center"
    })
    funFilterData(selBillType, selTradeOf, selPktType, null, null, null, null, null, null, null, null, null, null);
  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.memoEntry.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalAmt = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "NetAmt",
      }),
    [data]
  )

  let totalAmtD = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "NetAmtD",
      }),
    [data]
  )

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "Party_Name",
    "Memo_Det",
    "Chal_No",
    "NetAmt",
    "NetAmtD",
    "Chal_Date",
    "Account_Name",

  ]
  const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)

  const exportColumns = [
    {
      name: "PARTY NAME",
      uid: "Party_Name",
    },
    {
      name: "DESCRIPTION",
      uid: "Memo_Det",
    },
    {
      name: "Chal NO",
      uid: "Chal_No",
    },
    {
      name: "AMOUNT",
      uid: "NetAmt",
      type: COLUMN_TYPE.number,
    },
    {
      name: "AMOUNT($)",
      uid: "NetAmtD",
      type: COLUMN_TYPE.number,
    },
    {
      name: "DATE",
      uid: "Chal_Date",
      type: COLUMN_TYPE.date,
    },
    {
      name: "ACCOUNT",
      uid: "Account_Name",
    },
  ]

  const [exportCols, setExportCols] = useState(exportColumns)

  let downloadDataFooter = {
    Party_Name: "",
    Memo_Det: "",
    Chal_No: "",
    NetAmt: "Total: " + totalAmt,
    NetAmtD: "Total: " + totalAmtD,
    Chal_Date: "",
    Account_Name: "",
  }
  const [exportFooter, setExportFooter] = useState(downloadDataFooter)
  useEffect(() => {
    if (CurrencySetting && CurrencySetting != "") {
      let AmtColumn = ""
      if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS)
        AmtColumn = "NetAmtD"
      else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
        AmtColumn = "NetAmt"
      else {
        setInitialColumn(INITIAL_VISIBLE_COLUMNS)
        setExportCols(exportColumns)
        setExportFooter(downloadDataFooter)
      }

      if (AmtColumn != "") {
        const filterIniCol = initialColumn.filter(ele => ele != AmtColumn)
        const filterExpCol = exportColumns.filter((ele) => ele.uid != AmtColumn)
        //let footerCol = AmtColumn == 'NetAmtD' ? 'Amount$' : 'Amount'
        const filterExpFooter = Object.keys(downloadDataFooter).filter((ele) => ele != AmtColumn)
        setExportCols(filterExpCol)
        setInitialColumn(filterIniCol)
        setExportFooter(filterExpFooter)
      }
    }
  }, [CurrencySetting, data])

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "PARTY NAME",
      uid: "Party_Name",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Description",
      uid: "Memo_Det",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.left,
      type: COLUMN_TYPE.multiline
    },
    {
      name: "Chal NO",
      uid: "Chal_No",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "AMOUNT",
      uid: "NetAmt",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmt,
      },
    },
    {
      name: "AMOUNT($)",
      uid: "NetAmtD",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmtD,
      },
    },
    {
      name: "DATE",
      uid: "Chal_Date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "ACCOUNT",
      uid: "Account_Name",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
  ]

  const handleConfirmBox = (data) => {
    if (data) {
      if (itemToDelete != "" && itemToDelete != null && Object.keys(itemToDelete).length > 0) {
        FndeleteNote({
          data: {
            transaction_id: itemToDelete.transaction_id,
            comp_code: itemToDelete.comp_code,
            pkt_type: itemToDelete.pkt_type,
            bill_type: itemToDelete.bill_type,
            trade_of: selTradeOf,
            mkt_lotno: isUseMfgNoAsMktno ? '0' : "1"
          }
        })
      }
      else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
        disapatch(setReturnDetailParams(itemToEdit))
        disapatch(setReturnNewEntryMode(false))
        if (selPktType == 'MIX')
          navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.returnEntry.createReturnEntry)
        else
          navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.returnEntry.createReturnEntry)
      }
    }
    else {
      setItemToDelete("")
      setItemToEdit("")
      setPageActionType("")
    }

  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        setItemToDelete("")
        setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
        let obj = {
          comp_code: row.CompCode,
          transaction_id: row.TransactionId,
          bill_type: row.Bill_Type,
          trade_of: row.Trade_Of

        }
        setItemToEdit(obj)


      },
      type: ROW_ACTION_BTN_TYPE.link,
    },

    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {
        setItemToEdit("")
        setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
        setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.CompCode, pkt_type: row.PktType, bill_type: row.Bill_Type })
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  const handleAddNew = () => {
    disapatch(resetReturnDetailParams())
    if (selPktType == 'MIX')
      navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.returnEntry.createReturnEntry)
    else
      navigate(naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.returnEntry.createReturnEntry)

  }

  const ADVFILTER_VISIBLE_FIELD = [
    // ...Object.values(ENUM_ADVSEARCH_PARAM)
    ENUM_ADVSEARCH_PARAM.Shape,
    ENUM_ADVSEARCH_PARAM.Purity,
    ENUM_ADVSEARCH_PARAM.Color,
    ENUM_ADVSEARCH_PARAM.Size,
    ENUM_ADVSEARCH_PARAM.Party,
    ENUM_ADVSEARCH_PARAM.Broker,
    ENUM_ADVSEARCH_PARAM.Item,
    ENUM_ADVSEARCH_PARAM.LwRatio,
    ENUM_ADVSEARCH_PARAM.VouFromDate,
    ENUM_ADVSEARCH_PARAM.VouToDate,
    //ENUM_ADVSEARCH_PARAM.VouNo,
  ]
  const handleFilterChange = (newFilters) => {
    //console.log('Received filters in parent:', newFilters);
    setSelAdvanceFilter(newFilters)
    funFilterData(selBillType, selTradeOf, selPktType,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Shape) ? newFilters[ENUM_ADVSEARCH_PARAM.Shape] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Purity) ? newFilters[ENUM_ADVSEARCH_PARAM.Purity] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Size) ? newFilters[ENUM_ADVSEARCH_PARAM.Size] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Color) ? newFilters[ENUM_ADVSEARCH_PARAM.Color] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.LwRatio) ? newFilters[ENUM_ADVSEARCH_PARAM.LwRatio] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Item) ? newFilters[ENUM_ADVSEARCH_PARAM.Item] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Party) ? newFilters[ENUM_ADVSEARCH_PARAM.Party] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Broker) ? newFilters[ENUM_ADVSEARCH_PARAM.Broker] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouFromDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouToDate] : null,

    )

  };
  return (
    <div>


      {(itemToDelete || itemToEdit) && (
        <ConfirmBox
          handleConfirmBox={handleConfirmBox}
          actionType={pageActionType}
        />
      )}

      <MainContainer
        pageName={entryLabel + ` ${selBillType == 'T' ? 'Sale' : 'Purchase'} Return - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
        info={[]}
        breadcrumbs={[selBillType == 'T' ? 'Sale' : 'Purchase', entryLabel, "Return", selPktType == 'SNG' ? "Single Packet" : selPktType]}
      >

        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={initialColumn}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportCols}
          downloadDataFooter={exportFooter}
          downloadFileName={entryLabel + "memo-List"}
          advanceFilterParam={selAdvanceFilter}
          advFilterPageApiParam={pageApiAdvFilter}
          advFilterVisibleField={ADVFILTER_VISIBLE_FIELD}
          id="TransactionId"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default ReturnEntryMaster
